var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload"},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.action,"show-file-list":false,"before-upload":_vm.beforeAvatarUpload}},[_c('el-button',{attrs:{"type":"danger"}},[_vm._v("上传文件")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }